import React from 'react';
import { Box } from '@radix-ui/themes';

import { GraphQLTable, Column } from '../../components/GraphQLTable';
import {
  GetWorkflowsDocument,
  GetWorkflowsQuery,
  GetWorkflowsQueryVariables,
} from '../../graphql/queries/GetWorkflows.generated';

import TimeAgoTooltip from '../../components/TimeAgoTooltip';
import ViewButton from '../../components/ViewButton';

const WorkflowList: React.FC = () => {
  const columns: Column<GetWorkflowsQuery['workflows']['edges'][0]['node']>[] =
    [
      {
        header: 'Name',
        accessor: 'name',
      },
      {
        header: 'Created At',
        accessor: 'createdAt',
        render: ({ value }) => <TimeAgoTooltip value={value} />,
      },
      {
        header: null,
        render: ({ row }) => (
          <ViewButton to={`/workflows/${row.id}`} text="View Workflow" />
        ),
      },
    ];

  return (
    <Box>
      <GraphQLTable<
        GetWorkflowsQuery,
        GetWorkflowsQueryVariables,
        'workflows',
        GetWorkflowsQuery['workflows']['edges'][0]['node']
      >
        query={GetWorkflowsDocument}
        columns={columns}
        connectionPath="workflows"
        loadingMessage="Fetching latest workflows..."
        errorMessage="Failed to fetch workflows."
        noDataMessage="No workflows available."
      />
    </Box>
  );
};

export default WorkflowList;
